import React, {useMemo, useState} from "react";
import {Col, Row} from "antd";
import {ConfigureSystemAttributesBase} from "./ConfigureSystemAttributes";
import HierarchiesService from "../../services/HierarchiesService";
import {authHeader, download} from "../../Utilities";
import {API_URL} from "../../constants";
import axios from "axios";
import {SelectHierarchy} from "./SelectHierarchy";

export function ConfigureHierarchySystemAttributes({workspaceId}) {
    const [selectedHierarchy, setSelectedHierarchy] = useState(null);
    return (
        <Row gutter={16}>
            <Col span={8}>
                <SelectHierarchy
                    workspaceId={workspaceId}
                    onSelect={setSelectedHierarchy}
                />
            </Col>
            <Col span={16}>
                {selectedHierarchy && (
                    <ConfigureHierarchySystemAttributesInner
                        key={selectedHierarchy.id}
                        workspaceId={workspaceId}
                        hierarchy={selectedHierarchy}
                    />
                )}
            </Col>
        </Row>
    );
}


function ConfigureHierarchySystemAttributesInner({workspaceId, hierarchy}) {
    const loadSystemAttributes = useMemo(() => {
        return () => HierarchiesService
            .fetchSystemAttributes(hierarchy.id)
            .then(data => ({
                data: data.map(x => ({
                    object_label: x.label,
                    attribute_name: x.name,
                    values_list: x.options
                }))
            }));
    }, [hierarchy]);

    const onDownload = useMemo(() => {
        return () => axios.get(`${API_URL}/hierarchies/${hierarchy.id}/system_attributes/config`,
            {
                headers: authHeader(),
                responseType: 'blob'
            }).then((response) => {
            const blob = new window.Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
            download(blob, "hierarchy_system_attributes.xlsx");
        })
    }, [workspaceId]);

    return (
        <ConfigureSystemAttributesBase
            workspaceId={workspaceId}
            loadSystemAttributes={loadSystemAttributes}
            uploadAction={`${API_URL}/hierarchies/${hierarchy.id}/system_attributes/config`}
            onDownload={onDownload}
            mainTitle={`Configure system attributes of ${hierarchy.name}`}
        />
    );
}
